export const getCurrentPorcentageValue = (state) =>
    Math.round((state.loadingCounter.currentValue / state.loadingCounter.totalCount) * 100);

export const getCurrentValue = (state) => state.loadingCounter.currentValue;
